import { Box, Button, CircularProgress, MenuItem, Select, Stack } from '@mui/material';
import React, { useEffect, useState } from 'react';
import axios from 'axios';
import {
  align_row,
  VM_Colors,
  VM_FormContainer,
  VM_ResponsiveBox
} from '../../Styles/VMStyles';
import {
  PERSONAL_INFORMATION,
  SESSION_USER_ID_KEY,
  UPDATE_BELOW_DETAILS
} from '../../Util/VMConstants';
import { isEmpty } from '../../Util/UtilHelper';
import OTPDialog from '../../LoginRegistration/Registration/OTPDialog';
import TitleDesc from '../../Components/Custom/TitleDesc';
import useCountryList from '../../Hooks/useCountryList';
import { API_UPDATE_MOBILE_NUMB, API_UPDATE_USER_REGISTRATION } from '../../Util/URLConstants';
import { toast } from 'react-toastify';
import StorageFactory from '../../Util/StorageFactory';
import StyledInputField from '../../Components/Custom/StyledInputField';
import MuiTypographyMandatory from '../../Components/Custom/MuiTypographyMandatory';

function UpdateUserRegistration(props) {
  const [state, setState] = useState({
    user_name: '',
    country_code: '',
    mobile_no: '',
    email: '',
    countryID: '',
    showPassword: false,
    showConfirmPassword: false,
    passwordError: false,
    confirmPasswordError: false,
    loading: false,
    country_data:[],
    existPhNo:"",
    existPhCode:"",
  });

  const [showOtpDialog, setShowOtpDialog] = useState(false);
  const { country } = useCountryList();
  const { userState, onClose ,loadProfile } = props;
  const sessionFactory = new StorageFactory('session'); // or 'local' for localStorage

  const updateUserprofile = async(isMobileUpdate) =>{

    setState((prev) => ({ ...prev, loading: true }));

    const payload = {
      user_id: userState.user_id,
      name: state.user_name,
      mobile_no: state.mobile_no,
      country_code: state.country_code,
      country_data: isEmpty(state.country_data) ? userState.country_data : state.country_data ,
      mobileUpdate: isMobileUpdate,
      email: state.email,
      user_type: userState.user_type,
    };

    try {
      const response = await axios.post( API_UPDATE_USER_REGISTRATION,
        payload
      );
      setState((prev) => ({ ...prev, loading: false }));

      // Assuming success response handling
      toast.success(response.data?.message);
      // Optionally close dialog or do other actions
      
      if( isMobileUpdate === true){
         setShowOtpDialog(true);
      }else{
        if (onClose) onClose();
      }
          loadProfile();
    } catch (error) {
      setState((prev) => ({ ...prev, loading: false }));
      toast.error('Failed to update user. Please try again.');
      console.error('Update error:', error);
    }
  }

  useEffect(() => {
    if (!userState || !country?.length) return;

    const userCid = userState?.country_data?.cid;
    const userCode = String(
      userState?.country_data?.country_code ?? userState?.country_code ?? ""
    ).trim();

    const selectedObj =
      country.find((c) => String(c.cid) === String(userCid)) ||
      (userCode
        ? country.find((c) => String(c.country_code) === userCode)
        : null) ||
      null;

    setState((prev) => ({
      ...prev,
      user_name: userState.name || "",
      country_code: selectedObj?.country_code || userState.country_code || "",
      mobile_no: userState.mobile_no || "",
      email: userState.email || "",
      countryID: selectedObj?.cid ?? "",
      existPhNo: userState.mobile_no || "",
      existPhCode: selectedObj?.country_code || userState.country_code || "",
      country_data: selectedObj || userState.country_data || [],
    }));
  }, [country, userState]);

  // API call function for Update
  const handleUpdate = async () => {
    // Basic validation can be added here if needed
    if (!state.user_name || !state.mobile_no || !state.country_code) {
      toast.error('Please fill all required fields.');
      return;
    }
    console.log("state:",state);
    console.log("state.country_code === state.existPhCode:",state.country_code === state.existPhCode);
    console.log("state.mobile_no === state.existPhNo:",state.mobile_no === state.existPhNo);
    if(state.country_code === state.existPhCode && state.mobile_no === state.existPhNo){
     
      updateUserprofile(false);
    }else{
      updateUserprofile(true)
    }
  };
   const handleVerify = () => {
    
      const userID = sessionFactory.get(SESSION_USER_ID_KEY);
        console.log("userID:",userID);
        axios.get(API_UPDATE_MOBILE_NUMB+"?user_id="+userID)
        .then(resp=>{
           if (onClose) onClose();
            loadProfile();
        }).catch (err => {
        console.error("Error fetching country list:", err);
      })

   }

  return (
    <Box sx={VM_ResponsiveBox}>
      <Box sx={VM_FormContainer}>
        <TitleDesc title={PERSONAL_INFORMATION} subtitle={UPDATE_BELOW_DETAILS} />

        <StyledInputField
            heading="Your Name"
            name="user_name"
            placeholder="Enter Your Name"
            value={state.user_name}
            onChange={(e) => setState({ ...state, user_name: e.target.value })}
            fullWidth
            style={{ mt: 1 }}
          />

        {/* Country Code + Mobile Number */}
          <Box sx={{ ...align_row, my: 3, width: "100%" }}>
          
          <Stack spacing={0.5} sx={{minWidth:'200px', mr:2}}>
            <MuiTypographyMandatory label="Country" required />
            <Select
              name="country-select-label"
              value={state.countryID !== "" && state.countryID != null ? String(state.countryID) : ""}
              onChange={(event)=>{
                  const selectedCid = event.target.value;
                  const selectedObj = country.find((c) => String(c.cid) === String(selectedCid));
                  if (!selectedObj) return;
                  setState({
                    ...state,
                    countryID: selectedObj.cid,
                    country_code: selectedObj.country_code,
                    country_data: selectedObj,
                  });
                }}
                displayEmpty
                disabled={true}
                sx={{ width:'100%', backgroundColor: VM_Colors.white }}
            >
                 <MenuItem value="" disabled>  -- Select --   </MenuItem>
              {country.map((ctr) => (
                  <MenuItem key={ctr.cid} value={String(ctr.cid)}>
                    {ctr.country_name}
                  </MenuItem>
                ))}
            </Select>
          </Stack>
           
          <Box sx={{width:'100%'}}>
            <StyledInputField
            heading={isEmpty(state.country_code)
                        ? 'Mobile No'
                        : 'Mobile No ( +' + state.country_code + ' )'
                    }
            name="mobile_no"
            placeholder="Enter Your Mobile Number"
            value={state.mobile_no}
            onChange={(e) => setState({ ...state, mobile_no: e.target.value })}
            fullWidth
            inputProps={{ maxLength: 15, inputMode: 'numeric', pattern: '[0-9]*' }}
          />
          </Box>
        </Box>

      
        <StyledInputField
            heading="Email ID"
            name="email"
            placeholder="Enter Your Email Address"
            type="email"
            value={state.email}
            fullWidth
            disabled
          />
        
        {/* Buttons: Close (left) and Update (right) with same width */}
        <Box
          sx={{
            display: 'flex',
            justifyContent: 'space-between',
            mt: 4,
            gap: 2
          }}
        >
          <Button
            variant="outlined"
            onClick={onClose}
            sx={{
              flex: 1,
              borderRadius: 2,
              textTransform: 'none',
              fontWeight: 600,
              color: VM_Colors.primary,
              borderColor: VM_Colors.primary,
              px: 4,
              py: 1.5,
              '&:hover': {
                borderColor: VM_Colors.primary,
                backgroundColor: `${VM_Colors.primary}14`,
              }
            }}
          >
            Close
          </Button>

          <Button
            variant="contained"
            color="primary"
            onClick={handleUpdate}
            sx={{
              flex: 1,
              borderRadius: 2,
              px: 4,
              py: 1.5,
            }}
          >
            Update
          </Button>
        </Box>

        {/* OTP Dialog */}
        <OTPDialog
          showOtpDialog={showOtpDialog}
          handleClose={() => setShowOtpDialog(false)}
          arrived="userregistration"
          user_id={userState.user_id}
          handleNext ={handleVerify}
        />

      {
        state.loading ? 
        <CircularProgress loading={state.loading} />
        : null 
      }
      </Box>

    </Box>
  );
}

export default UpdateUserRegistration;
